import { removeNewLinesAndTabs } from '../../utils/removeNewLinesAndTabs';
import { removeSurrogatePairAndReplaceEmojiToText } from '../../utils/removeSurrogatePairAndReplaceEmojiToText';

export const prepareExtraCommentString = (str: string) => {
  const strWithoutEmoji = removeSurrogatePairAndReplaceEmojiToText(str);
  const strWithoutNewLines = removeNewLinesAndTabs(strWithoutEmoji);

  return strWithoutNewLines;
};
